<template>
  <div class="settings-container">
    <nav>
      <header>
        <base-button
            icon="arrow_back"
            type="transparent"
            size="large"
            @click="goBack"/>
        <h1>Settings</h1>
      </header>
      <settings-menu-list :items="menu"/>
    </nav>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import SettingsMenuList from '@/components/settings/SettingsMenuList.vue';

import GoogleDriveLogo from '@/assets/google-drive-logo.svg';

export default {
  name: 'TheSettings',
  components: {
    BaseButton,
    SettingsMenuList,
  },
  data() {
    return {
      menu: [
        {
          icon: 'settings',
          text: 'General',
          to: {
            name: 'settings-general',
          },
        },
        {
          icon: 'backup',
          text: 'Backup',
          to: {
            name: 'settings-backup',
          },
          items: [
            {
              customIcon: GoogleDriveLogo,
              text: 'Google Drive',
              to: {
                name: 'settings-backup-google-drive',
              },
            },
          ],
        },
        {
          icon: 'info',
          text: 'About',
          to: {
            name: 'settings-about',
          },
        },
      ],
    };
  },
  methods: {
    goBack() {
      const currentNote = this.$store.state.notes.current;

      let route;
      if (currentNote) {
        route = {
          name: 'note-editor',
          params: {
            id: currentNote.uuid,
          },
          query: this.$store.state.routeQuery,
        };
      } else {
        route = {
          name: 'notes',
        };
      }

      this.$router.push(route);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.settings-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  nav {
    background: $dark-gray-700;
    border-bottom: 0.0625rem solid $dark-gray-900;
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
    width: 24rem;

    header {
      align-items: center;
      border-bottom: 0.0625rem solid $dark-gray-900;
      display: flex;
      height: 4rem;
      padding: 0.25rem;

      h1 {
        font-size: 1.5rem;
        font-weight: normal;
        margin-left: 0.5rem;
      }
    }
  }

  main {
    background: $background;
    bottom: 0;
    left: 24rem;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
